export enum EValidationState {
  review = 'review',
  dismissed = 'dismissed',
  accepted = 'accepted',
  submitted = 'submitted'
}
